import type { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useQuery } from '@edreamsodigeo/frontend-api-client';

import type {
  GetUserAccountQuery,
  GetUserAccountQueryVariables,
  UserAccountRequest,
} from 'generated/graphql';
import { GET_USER_ACCOUNT } from '../providers/operations/userAccount';
import { useShoppingInfo } from './useShoppingInfo';

export interface UserAccount {
  queryKey?: UseQueryResult<
    GetUserAccountQuery,
    GetUserAccountQueryVariables
  >['queryKey'];
  errors: UseQueryResult<
    GetUserAccountQuery,
    GetUserAccountQueryVariables
  >['errors'];
  loading: UseQueryResult<
    GetUserAccountQuery,
    GetUserAccountQueryVariables
  >['loading'];
  data: UseQueryResult<
    GetUserAccountQuery,
    GetUserAccountQueryVariables
  >['data'];
}

const useUserAccount = (): UserAccount => {
  const shoppingInfo = useShoppingInfo();
  const userAccountRequest: UserAccountRequest = {
    shoppingInfo,
  };

  const { queryKey, data, loading, errors } = useQuery<
    GetUserAccountQuery,
    GetUserAccountQueryVariables
  >(GET_USER_ACCOUNT, {
    variables: {
      userAccountRequest,
    },
  });

  return {
    queryKey,
    data,
    loading,
    errors,
  };
};

export default useUserAccount;
